import React, { useState } from 'react';
import { Alert, Avatar, Button, Empty, Pagination, Skeleton, Tag } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import { Navigate, useParams } from 'react-router-dom';
import FeaturePage from '@/components/featurepage';
import PostCard from '@/components/postcard';
import { fetchPublicPosts, fetchPublicProfile } from '@/apis/schools';
import usePrivateList from '@/utils/usePrivateList';
import { isResourceId } from '@/utils/queryParams';
import './index.scss';

const loadProfile = async ({ userId, page }) => {
  if (!isResourceId(userId)) throw new Error('用户编号无效');
  const [profile, posts] = await Promise.all([fetchPublicProfile(userId), fetchPublicPosts(userId, { page, pageSize: 10 })]);
  if (!Array.isArray(posts.data) || !posts.pagination) throw new Error('用户帖子响应无效');
  return { profile, posts };
};
const profileError = err => err.response?.status === 404 ? '该用户主页当前不可用' : '用户主页加载失败，请重试';
const ProfileContent = ({ userId }) => {
  const [page, setPage] = useState(1);
  const { data, loading, error, load, isAuthenticated } = usePrivateList(loadProfile, { userId, page }, profileError);
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  const profile = data?.profile;
  return <FeaturePage className="publicProfile" back="/" title="用户主页" subtitle="查看公开资料和发布的帖子。">
    {loading ? <Skeleton active avatar /> : error ? <Alert type="warning" title={error} action={<Button onClick={() => load().catch(() => {})}>重试</Button>} /> : profile && <>
      <section className="featurePage-panel publicProfile-summary"><Avatar size={64} src={profile.avatar || undefined} icon={<UserOutlined />} /><div><h2>{profile.nickname || profile.username}</h2><p>@{profile.username} · UID {profile.id}</p><div>{['M', 'F'].includes(profile.gender) && <Tag>{profile.gender === 'M' ? '男' : '女'}</Tag>}{profile.personality_type && <Tag>{profile.personality_type}</Tag>}</div></div></section>
      <div className="publicProfile-heading"><h2>发布的帖子</h2><span>共 {data.posts.pagination.total} 条</span></div>
      {!data.posts.data.length && <Empty description="暂无公开帖子" />}
      <div className="publicProfile-posts">{data.posts.data.map(post => <PostCard post={post} key={post.id} />)}</div>
      {data.posts.pagination.total > 10 && <Pagination current={page} pageSize={10} total={data.posts.pagination.total} showSizeChanger={false} onChange={setPage} />}
    </>}
  </FeaturePage>;
};
const PublicProfile = () => { const { userId } = useParams(); return <ProfileContent key={userId} userId={userId} />; };
export default PublicProfile;
